import { CreateActivityLogComponent } from './components/new-activitylog.component';
import { ActivityLogListComponent } from './components/activitylog-list.component';
import { AuthGuard } from './../../_guards/auth.guard';
import { Route } from '@angular/router';
export const activityLogRoutes: Route[] = [
    {
        path: 'activititylog',
        component: ActivityLogListComponent,
      
    },
    {
        path: 'activitylog/new',
        component: CreateActivityLogComponent,

    }
]